import { useEffect, useState } from 'react'
import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import ConversationItem from '../components/molecules/ConversationItem'
import { getConversationList } from '../api/conversation'
import Text from '../components/atoms/Text'
import { useNavigate } from 'react-router-dom'
import { tutorialPageKeys } from '../data/tutorialConfig'
import { useTutorial } from '../hooks/useTutorial'
import { tutorialImages } from '../data/tutorialImages'
import TutorialOverlay from '../components/molecules/auth/TutorialOverlay'
import { logEvent } from '../utils/eventLogger'
import { useRegisterStatus } from '../hooks/useRegisterStatus'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
`
const Emptymessage = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 220px; // 임시
`
const ConversationNotes = () => {
  // 아이 및 음성 등록 여부 훅
  const { registerInfo, isLoading: isStatusLoading } = useRegisterStatus();

  // 튜토리얼 훅
  const page = tutorialPageKeys.CONVERSATION_NOTE;
  const { show, complete } = useTutorial(page);
  const datas = tutorialImages.CONVERSATION_NOTE.steps;

  const [conversations, setConversations] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // 로그 기록
    logEvent("records_view");
    
    const fetchConversationList = async() => {
      setIsLoading(true);
      try {
        const rlt = await getConversationList();
        setConversations(rlt.conversations)
        // console.log(rlt)
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoading(false);
      }
    }
    fetchConversationList()
  }, [])


  const navigate = useNavigate();

  const handleNavigate = (item) => {
    const { hrId, mappingYn } = item;
        
    if (mappingYn) {
      // 검토 완료 상태일 때
      logEvent("record_detail_view", { hrId: hrId });
    } else {
      // 검토 전 상태일 때
      logEvent("labeling_start", { hrId: hrId });
    }  
    
    navigate(`/conversations/${hrId}`);
  }

  const handleAddConversation = () => {
    // 로딩 중일 때는 클릭 방지
    if (isStatusLoading) return;

    if (!registerInfo?.isChildRegistered) {
      alert('아이를 등록해주세요');
      // navigate('/mypage/child-register');
      return;
    }
    if (!registerInfo?.isVoiceRegistered) {
      alert('아이 음성을 등록해주세요');
      // navigate('/mypage/voice-register');
      return;
    }

    // 로그 기록
    logEvent("recording_start")

    navigate(`/conversation-word`)
  }

  return (
  <DefaultLayout
    headerType="main"
    variant="action"
    onAdd={handleAddConversation}
    title="대화노트"
    hasNavBar={true}
    bgColor="gray">
    <Wrapper>
      {isLoading? null : (
        conversations.length > 0 ? (
          conversations.map((item) => (
            <ConversationItem key={item.hrId} data={item} onClick={() => handleNavigate(item)} />
          ))
        ) : (
          <Emptymessage>
            <Text variant="headline3" weight="medium">녹음한 대화가 없어요.</Text>
            <Text variant="body2" color="alternative">아이와 대화를 녹음해보세요.</Text>
          </Emptymessage>
        )
      )}
    </Wrapper>
    {show && <TutorialOverlay datas={datas} onClose={complete} />}
  </DefaultLayout>
  )
}

export default ConversationNotes